import React, { FC } from 'react';
import translate from '@translate';
import { useNavigate } from 'react-router-dom';
import BodyTopBlock from 'src/components/BodyTopBlock';
import { AddIcon, ReloadIcon } from 'src/components/SkladonIcon/Icons';
import TopBlockAdmin from '../AdminContainer/TopBlock';
import { ExportTypeType, SelectRowType } from 'src/types/table';
import ExportTableAction from 'src/components/ExportTableAction';
import { useCheckPermission } from '../../utils/checkPermission';

type TopBlockProps = {
    reloadProvidersList: () => void;
    permissionCreate: boolean;
    permissionUpdate: boolean;
    handleExport: (type: ExportTypeType) => void;
    activeTab: string;
    setActiveTab: (value: string) => void;
    selectedRows: SelectRowType[];
};
const TopBlock: FC<TopBlockProps> = (props) => {
    const navigate = useNavigate();
    const permissionExportProviders = useCheckPermission('PROVIDER.EXPORT');

    const handleChange = (value: string) => {
        props.setActiveTab(value);
    };

    const handleNew = () => {
        navigate(`/admin/providers/new`);
    };

    return (
        <>
            <TopBlockAdmin />
            <BodyTopBlock
                tabs={[
                    { value: 'providers', label: translate('providers.providers') },
                    { value: 'providersWaiting', label: translate('providers.providersWaiting') },
                ]}
                selectTab={props.activeTab}
                onChangeTab={handleChange}
                actions={[
                    {
                        node: (
                            <ExportTableAction
                                title={
                                    props.selectedRows.length > 0
                                        ? `${translate('providers.action.exportFile')} (${props.selectedRows.length})`
                                        : translate('providers.action.exportFile')
                                }
                                handleExport={props.handleExport}
                            />
                        ),
                        hidden: !permissionExportProviders,
                    },
                    {
                        onClick: props.reloadProvidersList,
                        icon: <ReloadIcon />,
                        tooltip: translate('providers.action.synchronizeTable'),
                        variant: 'outlined',
                    },
                    {
                        label: translate('providers.action.createNew'),
                        onClick: handleNew,
                        icon: <AddIcon />,
                        hidden: !props.permissionCreate,
                    },
                ]}
            />
        </>
    );
};

export default TopBlock;
